import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@hijyenpro.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Hoş geldiniz!");
      nav("/");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const status = err.response?.status;
      let msg = "Giriş başarısız";
      if (typeof detail === "string") msg = detail;
      else if (!err.response) msg = "Sunucuya bağlanılamadı (ağ/CORS hatası). Lütfen tekrar deneyin.";
      else if (status === 422) msg = "Geçerli bir e-posta adresi girin";
      else if (status >= 500) msg = `Sunucu hatası (${status})`;
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-slate-50">
      <div className="hidden lg:flex flex-1 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1627905646269-7f034dcc5738?crop=entropy&cs=srgb&fm=jpg&q=85"
             alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/80 to-slate-900/90" />
        <div className="relative z-10 flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center">
              <Sparkles className="h-6 w-6" />
            </div>
            <div className="text-2xl font-bold" style={{ fontFamily: "Outfit" }}>HijyenPro</div>
          </div>
          <div>
            <h2 className="text-5xl font-bold leading-tight mb-4" style={{ fontFamily: "Outfit" }}>
              Temizlik işlerinizi tek yerden yönetin
            </h2>
            <p className="text-lg text-white/80 max-w-md">
              Gelir, gider, çalışan hakedişleri, tekrarlayan görevler ve daha fazlası — tek panelde.
            </p>
          </div>
          <div className="text-sm text-white/50">© 2026 HijyenPro</div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <Card className="w-full max-w-md p-8 shadow-xl border-slate-200">
          <div className="lg:hidden flex items-center gap-3 mb-6">
            <div className="h-10 w-10 rounded-xl bg-emerald-600 flex items-center justify-center text-white">
              <Sparkles className="h-5 w-5" />
            </div>
            <div className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>HijyenPro</div>
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit" }}>Giriş Yap</h1>
          <p className="text-slate-500 mb-8">Hesabınıza erişmek için bilgilerinizi girin</p>

          <form onSubmit={handle} className="space-y-5">
            <div>
              <Label htmlFor="email">E-posta</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                     data-testid="login-email-input" className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Şifre</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                     data-testid="login-password-input" className="mt-1.5" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit-button"
                    className="w-full bg-emerald-600 hover:bg-emerald-700 h-11 text-base">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Giriş Yap"}
            </Button>
          </form>

          <p className="text-center text-sm text-slate-500 mt-6">
            Hesabınız yok mu?{" "}
            <Link to="/register" className="text-emerald-700 font-medium hover:underline" data-testid="goto-register">
              Kayıt olun
            </Link>
          </p>
        </Card>
      </div>
    </div>
  );
}
